// @ts-check

export const ESTIMATION_AGENT_MAX_ATTACHMENTS = 5

export const ESTIMATION_AGENT_MAX_FILE_BYTES = 15 * 1024 * 1024

export const ESTIMATION_AGENT_FILE_INPUT_ACCEPT = "image/*,.pdf,application/pdf"

/**
 * @param {string} name
 * @returns {string | undefined}
 */
function guessMimeFromFilename(name) {
  const lower = name.toLowerCase()
  if (lower.endsWith(".pdf")) return "application/pdf"
  if (lower.endsWith(".png")) return "image/png"
  if (lower.endsWith(".jpg") || lower.endsWith(".jpeg")) return "image/jpeg"
  if (lower.endsWith(".gif")) return "image/gif"
  if (lower.endsWith(".webp")) return "image/webp"
  return undefined
}

/**
 * @param {File} file
 * @returns {boolean}
 */
export function isAllowedEstimationAttachmentFile(file) {
  const t = file.type
  if (t === "application/pdf") return true
  if (typeof t === "string" && t.startsWith("image/")) return true
  if (!t || t === "") {
    const g = guessMimeFromFilename(file.name)
    return g === "application/pdf" || (g != null && g.startsWith("image/"))
  }
  return false
}

/**
 * @param {File} file
 * @returns {string}
 */
export function mediaTypeForEstimationFile(file) {
  if (file.type && file.type !== "") return file.type
  return guessMimeFromFilename(file.name) ?? "application/octet-stream"
}

/**
 * @param {string} mediaType
 * @returns {boolean}
 */
export function isPdfMediaType(mediaType) {
  return mediaType === "application/pdf"
}
